import SvgIcon from '@mui/material/SvgIcon';

export default function SendRequestIcon() {
  return (
    <SvgIcon>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.146 3H5.146C4.61556 3 4.10686 3.21071 3.73178 3.58579C3.35671 3.96086 3.146 4.46957 3.146 5V19C3.146 19.5304 3.35671 20.0391 3.73178 20.4142C4.10686 20.7893 4.61556 21 5.146 21H19.146C19.6764 21 20.1851 20.7893 20.5602 20.4142C20.9353 20.0391 21.146 19.5304 21.146 19V12"
          stroke="#212121"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.5211 2.62523C18.9189 2.2274 19.4585 2.00391 20.0211 2.00391C20.5837 2.00391 21.1233 2.2274 21.5211 2.62523C21.9189 3.02305 22.1424 3.56262 22.1424 4.12523C22.1424 4.68784 21.9189 5.2274 21.5211 5.62523L12.5081 14.6392C12.2706 14.8765 11.9773 15.0501 11.6551 15.1442L8.78209 15.9842C8.69604 16.0093 8.60483 16.0108 8.518 15.9886C8.43117 15.9663 8.35192 15.9212 8.28854 15.8578C8.22516 15.7944 8.17998 15.7151 8.15773 15.6283C8.13549 15.5415 8.13699 15.4503 8.16209 15.3642L9.00209 12.4912C9.09662 12.1693 9.27062 11.8763 9.50809 11.6392L18.5211 2.62523Z"
          stroke="#212121"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
